import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class ProjectDigestsService {
  constructor(private http: HttpClient) {}

  public get(params: any) {
    let projectId;

    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/digests`;

    return this.http.get(url, { params });
  }

  public comparison(params: any) {
    let projectId;
    let projectDigestId;

    [params, projectId, projectDigestId] = splayParams(
      params,
      "projectId",
      "projectDigestId",
    );
    const url = `/api/v4/projects/${projectId}/digests/${projectDigestId}/comparison`;

    return this.http.get(url, { params });
  }
}
